import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';

import { IGetSpecialPromoResponse } from '../../../shared/repositories/special-promos/v1/get-special-promo';

import { App } from '../../../shared/components/app';
import { YmapsApi } from '../../ymaps/ymaps-api';

export function renderApplication() {
  const config = getConfig();
  const logger = getLogger();
  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  const ymaps = new YmapsApi();
  const specialPromo = config.getStrict<IGetSpecialPromoResponse>('specialPromo');
  const currentYear = config.get<number>('currentYear') || new Date().getFullYear();

  ReactDOM.hydrateRoot(
    rootElement,
    <App ymaps={ymaps} specialPromo={specialPromo} logger={logger} currentYear={currentYear} />,
  );
}
